import React, { useState } from 'react';
import { API_URL, secret_key, storedData } from '../Constants';
import axios from 'axios';
import Swal from "sweetalert2";
import Modal from 'react-modal';
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import BuyUnits from '../BuyUnits';
import { BiSolidUserCircle } from 'react-icons/bi';
import avatar from '../../assets/Logo.png';

Modal.setAppElement('#root');

const customStylesForReset = {
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minWidth: '350px',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: '2rem',
    borderRadius: '12px',
    backgroundColor: '#fff',
    boxShadow: '0 5px 20px rgba(0,0,0,0.15)'
  },
};

function Menubar() {
  const navigate = useNavigate();

  // Decrypt user data once here
  let userData = null;
  try {
    if (storedData) {
      const decrypted = CryptoJS.AES.decrypt(storedData, secret_key).toString(CryptoJS.enc.Utf8);
      if (decrypted && decrypted.trim().length > 0) {
        userData = JSON.parse(decrypted);
      }
    }
  } catch (err) {
    console.error("Failed to parse stored userData:", err);
    localStorage.removeItem('storedData'); // cleanup
  }

  const [editmodalIsOpen, setEditIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [editpassword, seteditpassword] = useState({
    email: userData?.email || '',
    company_id: userData?.company_id || '',
    password: "",
    old_password: ""
  });

  // Decrypt token once
  const token = (() => {
    const encryptedToken = localStorage.getItem('token');
    if (!encryptedToken) return '';
    try {
      const decryptedToken = CryptoJS.AES.decrypt(encryptedToken, secret_key).toString(CryptoJS.enc.Utf8);
      return decryptedToken ? `Bearer ${decryptedToken}` : '';
    } catch {
      console.error('Token decryption failed');
      return '';
    }
  })();

  const openEditModal = () => setEditIsOpen(true);
  const closeEditModal = () => setEditIsOpen(false);

  const handleeditChange = (e) => {
    const { id, value } = e.target;
    seteditpassword(prev => ({ ...prev, [id]: value }));
  };

  const editContactGroup = async (ev) => {
    ev.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.put(`${API_URL}/user_reset_password`, editpassword, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      });
      await Swal.fire({
        icon: "success",
        title: "Password Updated",
        text: "Your password has been successfully changed."
      });
      navigate(0);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error?.response?.data?.error || "Something went wrong."
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('storedData');
    localStorage.removeItem('token');
    // Remove other relevant keys here if needed
    navigate(0);
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light fixed-top shadow-sm">
      <ul className="navbar-nav align-items-center">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#"><i className="fas fa-bars" /></a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <a href="/" className="nav-link d-flex align-items-center">
            <img
              src={avatar}
              alt="Logo"
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'cover',
                borderRadius: '8px',
                marginRight: '10px'
              }}
            />
            <span className="font-weight-bold text-uppercase text-primary" style={{ fontSize: '16px' }}>
              {userData?.company_name}
            </span>
          </a>
        </li>

{/*         <li className="nav-item" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <BuyUnits />
        </li> */}
      </ul>

      <div className="ml-auto dropdown user-profile-dropdown">
        <button
          className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
          data-toggle="dropdown"
          style={{ gap: '10px', border: 'none', background: 'transparent', padding: '5px 10px' }}
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <BiSolidUserCircle size={32} color="#226f84" />
          <span className="d-none d-md-inline" style={{ fontWeight: 500 }}>
            {userData?.full_name}
          </span>
        </button>
        <ul className="dropdown-menu dropdown-menu-right companyActions shadow-sm rounded" aria-labelledby="dropdownMenuButton">
          <li>
            <button className="dropdown-item" onClick={openEditModal} type="button">
              <i className="fa fa-key mr-2"></i>Reset Password
            </button>
          </li>
          <li>
            <button className="dropdown-item" onClick={logout} type="button">
              <i className="fa fa-sign-out mr-2"></i>Logout
            </button>
          </li>
        </ul>
      </div>

      <Modal
        isOpen={editmodalIsOpen}
        onRequestClose={closeEditModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={customStylesForReset}
        contentLabel="Reset Password Modal"
      >
        <div className="modal-body">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title">Change Password</h5>
            <button className="close" onClick={closeEditModal} type="button" aria-label="Close">
              <i className="fa fa-times" />
            </button>
          </div>

          <form onSubmit={editContactGroup} className="mt-3">
            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                readOnly
                value={editpassword.email}
                style={{ backgroundColor: '#f1f1f1' }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="old_password">Old Password</label>
              <input
                type="password"
                className="form-control"
                id="old_password"
                placeholder="Enter old password"
                onChange={handleeditChange}
                required
                autoComplete="current-password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter new password"
                onChange={handleeditChange}
                required
                autoComplete="new-password"
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 mt-3" disabled={isSubmitting}>
              {isSubmitting ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </Modal>
    </nav>
  );
}

export default Menubar;
